/**
 * Settings Actions Component Exports
 *
 * @since 1.0.0
 */

export { SettingsActions } from './component';
